<template>
  <validation-observer
    v-if="options"
    ref="observer"
    tag="form"
    class="modal-add-option"
    @submit.prevent="addNewOption">
    <h3 v-if="options.header">
      {{ options.header }}
    </h3>

    <p>
      {{ options.text }}
    </p>
    <validation-provider
      v-slot="{ errors }"
      rules="required"
      mode="lazy"
      slim>
      <oie-base-input
        v-model="option"
        placeholder="Add new option"
        :auto-focus="true"
        :error-messages="errors"
        @keydown.enter="addNewOption"></oie-base-input>
    </validation-provider>

    <oie-action-wrapper>
      <template #left>
        <oie-base-action
          :key="options.action.text"
          size="large"
          type="submit">
          {{ options.action.text }}
        </oie-base-action>

        <oie-base-action
          size="large"
          theme="skeleton"
          @click="$modal.hide(options.name)">
          {{ tStatic('modalCancel') }}
        </oie-base-action>
      </template>
    </oie-action-wrapper>
  </validation-observer>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      option: '',
      error: ''
    }
  },
  mounted() {
    this.option = this.options.initialValue
  },
  methods: {
    async addNewOption() {
      const isValid = await this.$refs.observer.validate()
      if(isValid) {
        this.error = await this.options.action.handler(this.option, this.options.type)
        if(!this.error) {
          this.$modal.hide(this.options.name)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.modal-add-option >*:not(:last-child){
  margin-bottom: measure(quarter);
}
</style>
